import { call, put, takeEvery, all, fork } from "redux-saga/effects";

// Crypto Redux States
import { GET_TOP_SELLING_PRODUCT, GET_EARNING_DATA, GET_REPORTED_MESSAGES, CHANGE_REPORTED_MESSAGE_STATUS } from "./actionType";
import {
    getTopSellingProductSuccess,
    getTopSellingProductFail,
    getEarningSuccess,
    getEarningFail,
    getReportedMessagesSuccess,
    getReportedMessagesFail,
    changeReportedMessageStatusSuccess,
    changeReportedMessageStatusFail,
} from "./actions";

//Include Both Helper File with needed methods
import {
    topSellingData as topSellingDataApi,
    getEarningChartsData as getEarningChartsDataApi
}
    from "../../helpers/fakebackend_helper";

import { get, post } from "../../helpers/api_helper";

function* getSellingData({ payload: month }) {
    try {
        var response = yield call(topSellingDataApi, month);
        yield put(apiSuccess(GET_TOP_SELLING_PRODUCT, response));
    } catch (error) {
        yield put(apiFail(GET_TOP_SELLING_PRODUCT, error));
    }
}


function* getEarningChartsData({ payload: month }) {
    try {
        var response = yield call(getEarningChartsDataApi, month);
        yield put(apiSuccess(GET_EARNING_DATA, response));
    } catch (error) {
        yield put(apiFail(GET_EARNING_DATA, error));
    }
}

function* fetchReportedMessages({ payload }) {
    try {
        const response = yield call(get, `/api/admin/reported-messages?page=${payload.page}&limit=${payload.limit}`);
        yield put(getReportedMessagesSuccess(response));
    } catch (error) {
        yield put(getReportedMessagesFail(error));
    }
}

function* changeReportedMessageStatus({ payload }) {
    try {
        const response = yield call(post, `/api/report-message/change-status`, payload);
        yield put(changeReportedMessageStatusSuccess(response));
        // Refresh the reported messages list after status change
        yield put({ type: GET_REPORTED_MESSAGES, payload: { page: 1, limit: 10 } });
    } catch (error) {
        yield put(changeReportedMessageStatusFail(error));
    }
}

export function* watchGetSellingdata() {
    yield takeEvery(GET_TOP_SELLING_PRODUCT, getSellingData);
}

export function* watchGetEarningChartsData() {
    yield takeEvery(GET_EARNING_DATA, getEarningChartsData);
}

export function* watchGetReportedMessages() {
    yield takeEvery(GET_REPORTED_MESSAGES, fetchReportedMessages);
}

export function* watchChangeReportedMessageStatus() {
    yield takeEvery(CHANGE_REPORTED_MESSAGE_STATUS, changeReportedMessageStatus);
}

function* dashboardSaasSaga() {
    yield all([
        fork(watchGetSellingdata),
        fork(watchGetEarningChartsData),
        fork(watchGetReportedMessages),
        fork(watchChangeReportedMessageStatus),
    ]);
}

export default dashboardSaasSaga;
